import WalletScreen from "@components/Account/Wallet/WalletScreen";

export default WalletScreen;
